var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserAccountAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3131_21287",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5455 14.25V10.875H15.2727V8.625H18.5455V5.25H20.7273V8.625H24V10.875H20.7273V14.25H18.5455ZM8.72727 12C7.52727 12 6.5 11.5594 5.64545 10.6781C4.79091 9.79688 4.36364 8.7375 4.36364 7.5C4.36364 6.2625 4.79091 5.20312 5.64545 4.32188C6.5 3.44063 7.52727 3 8.72727 3C9.92727 3 10.9545 3.44063 11.8091 4.32188C12.6636 5.20312 13.0909 6.2625 13.0909 7.5C13.0909 8.7375 12.6636 9.79688 11.8091 10.6781C10.9545 11.5594 9.92727 12 8.72727 12ZM0 21V17.85C0 17.2125 0.159091 16.6266 0.477273 16.0922C0.795455 15.5578 1.21818 15.15 1.74545 14.8688C2.87273 14.2875 4.01818 13.8516 5.18182 13.5609C6.34545 13.2703 7.52727 13.125 8.72727 13.125C9.92727 13.125 11.1091 13.2703 12.2727 13.5609C13.4364 13.8516 14.5818 14.2875 15.7091 14.8688C16.2364 15.15 16.6591 15.5578 16.9773 16.0922C17.2955 16.6266 17.4545 17.2125 17.4545 17.85V21H0ZM2.18182 18.75H15.2727V17.85C15.2727 17.6438 15.2227 17.4563 15.1227 17.2875C15.0227 17.1187 14.8909 16.9875 14.7273 16.8938C13.7455 16.3875 12.7545 16.0078 11.7545 15.7547C10.7545 15.5016 9.74545 15.375 8.72727 15.375C7.70909 15.375 6.7 15.5016 5.7 15.7547C4.7 16.0078 3.70909 16.3875 2.72727 16.8938C2.56364 16.9875 2.43182 17.1187 2.33182 17.2875C2.23182 17.4563 2.18182 17.6438 2.18182 17.85V18.75ZM8.72727 9.75C9.32727 9.75 9.84091 9.52969 10.2682 9.08906C10.6955 8.64844 10.9091 8.11875 10.9091 7.5C10.9091 6.88125 10.6955 6.35156 10.2682 5.91094C9.84091 5.47031 9.32727 5.25 8.72727 5.25C8.12727 5.25 7.61364 5.47031 7.18636 5.91094C6.75909 6.35156 6.54545 6.88125 6.54545 7.5C6.54545 8.11875 6.75909 8.64844 7.18636 9.08906C7.61364 9.52969 8.12727 9.75 8.72727 9.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAccountAdd);
export default __webpack_public_path__ + "static/media/user-account-add.b2b73fc4d2fbb49a869a9e27de810558.svg";
export { ForwardRef as ReactComponent };